// @import dependencies
// @end

// @import event types
import { IMyCourseTab } from 'app_types/campus/academic/myCoursesTypes'
import {IStateCourses, ICoursesActionTypes, COURSE_SELECTED_CHANGE, COURSE_TAB_CHANGE} from './types'
// @end

const initialState: IStateCourses = {
  courseSelected: null,
  courseTab: IMyCourseTab.CURRENT_COURSES
}

export function coursesReducer(
  state = initialState,
  action: ICoursesActionTypes,
): IStateCourses {
  switch (action.type) {
    case COURSE_SELECTED_CHANGE:
      return {
        ...state,
        courseSelected: action.payload
      }
    case COURSE_TAB_CHANGE:
      return {
        ...state,
        courseTab: action.payload
      }
    default:
      return state
  }
}
